import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';
import { camelCaseObjectKeys } from 'utils/camelCase';
import initialState from './initialState';

const getCommonValues = (payload) => {
  const { title, metaDescription, metaRobots, canonical, heading1, heading2 } = payload;
  return {
    fetchStatus: LoadingStatus.Succeeded,
    title,
    metaDescription,
    metaRobots,
    canonical,
    heading1,
    heading2,
  };
};

const housingProductLocationContentSlice = createSlice({
  name: 'housingProductLocationContent',
  initialState,
  reducers: {
    fetch: (state) => {
      state.fetchStatus = LoadingStatus.Loading;
    },
    fetchFulfilledState: (state, action) => {
      const payload = camelCaseObjectKeys(action.payload);
      const commonValues = getCommonValues(payload);
      Object.assign(state, commonValues);
      state.marketOverviewTitle = payload.marketOverviewTitle;
      state.marketOverviewContent = payload.marketOverviewContent;
      state.marketOverviewStats = action.payload.MarketOverviewStats || null;
      state.specialCommunities = payload.specialCommunities;
      state.faqTitle = payload.faqTitle;
      state.faqContent = payload.faqContent;
      state.guidesTitle = payload.guidesTitle;
      state.guidesContent = payload.guidesContent;
      state.articleTitle = payload.articleTitle;
      state.articleContent = payload.articleContent;
      state.topMarketsTitle = payload.topMarketsTitle;
    },
    fetchFulfilled: (state, action) => {
      const payload = camelCaseObjectKeys(action.payload);
      const commonValues = getCommonValues(payload);
      Object.assign(state, commonValues);
      state.footer = payload.footer;
    },
    fetchError: (state) => {
      state.fetchStatus = LoadingStatus.Failed;
    },
  },
});

// Extract the action creators object and the reducer
export default housingProductLocationContentSlice;
